import auditStatus from '@/constants/auditStatus'
import { getIdPass, getPoaPass } from '@/util/register/getAuditPass'

export default {
  idPass: state => getIdPass(state.poiAuditStatus, state.ibtPoiAuditStatus, state.id3Pass),
  poaPass: state => getPoaPass(state.poaAuditStatus, state.ibtPoaAuditStatus),
  hasAccountAuditPending: state =>
    // Will be initially "Submitted" when account created
    (state.registerStep > 4 && state.accountAuditStatus === auditStatus.submitted) ||
    state.accountAuditStatus === auditStatus.pending ||
    state.accountAuditStatus === auditStatus.reaudit,
  isPoiUnderReview: (state, getters) =>
    !getters.idPass && (state.poiAuditStatus === auditStatus.submitted || state.poiAuditStatus === auditStatus.reaudit),
  isPoaUnderReview: (state, getters) =>
    !getters.poaPass &&
    (state.poaAuditStatus === auditStatus.submitted || state.poaAuditStatus === auditStatus.reaudit),
  isIbtPoiUnderReview: state =>
    state.ibtPoiAuditStatus === auditStatus.submitted || state.ibtPoiAuditStatus === auditStatus.reaudit,
  isIbtPoaUnderReview: state =>
    state.ibtPoaAuditStatus === auditStatus.submitted || state.ibtPoaAuditStatus === auditStatus.reaudit,
  isPoiEditable: (state, getters) =>
    !getters.idPass &&
    (state.poiAuditStatus === auditStatus.init ||
      state.poiAuditStatus === auditStatus.pending ||
      state.poiAuditStatus === auditStatus.rejected),
  isPoaEditable: (state, getters) =>
    !getters.poaPass &&
    (state.poaAuditStatus === auditStatus.init ||
      state.poaAuditStatus === auditStatus.pending ||
      state.poaAuditStatus === auditStatus.rejected),
  isIbtPoiEditable: state =>
    state.ibtPoiAuditStatus === auditStatus.init ||
    state.ibtPoiAuditStatus === auditStatus.pending ||
    state.ibtPoiAuditStatus === auditStatus.rejected,
  isIbtPoaEditable: state =>
    state.ibtPoaAuditStatus === auditStatus.init ||
    state.ibtPoaAuditStatus === auditStatus.pending ||
    state.ibtPoaAuditStatus === auditStatus.rejected,
  isPoiResubmit: (state, getters) =>
    // Check ID3 pass
    !getters.idPass && (state.poiAuditStatus === auditStatus.pending || state.poiAuditStatus === auditStatus.rejected),
  isPoaResubmit: (state, getters) =>
    !getters.poaPass && (state.poaAuditStatus === auditStatus.pending || state.poaAuditStatus === auditStatus.rejected),
  isIbtPoiResubmit: state =>
    state.ibtPoiAuditStatus === auditStatus.pending || state.ibtPoiAuditStatus === auditStatus.rejected,
  isIbtPoaResubmit: state =>
    state.ibtPoaAuditStatus === auditStatus.pending || state.ibtPoaAuditStatus === auditStatus.rejected,
}
